var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("body", { staticClass: "akl", attrs: { "data-v-7ba5bd90": "" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "renew-compliance" },
      [
        _c("div", { staticClass: "general-header" }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container amway-theme", attrs: { id: "contents" } },
          [
            _c("h1", { staticClass: "title-h2" }, [
              _vm._v("Member 약관 및 개인정보 동의")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "compliance-area privacy" }, [
              _c("div", { staticClass: "termsWrapper" }, [
                _c("div", { staticClass: "col-search-tab link-to" }, [
                  _c("span", {
                    staticClass: "scrollable-area left",
                    staticStyle: { display: "none" }
                  }),
                  _c("span", {
                    staticClass: "scrollable-area right",
                    staticStyle: { display: "none" }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tabWrapper" }, [
                    _c("ul", [
                      _c("li", { staticClass: "active" }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo01")
                              }
                            }
                          },
                          [_vm._v("이용약관")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo02")
                              }
                            }
                          },
                          [_vm._v("계약 동의서")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo03")
                              }
                            }
                          },
                          [_vm._v("유의사항")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo04")
                              }
                            }
                          },
                          [_vm._v("개인정보 이용")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo06")
                              }
                            }
                          },
                          [_vm._v("개인정보 제공")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.scrollToElement("titNo07")
                              }
                            }
                          },
                          [_vm._v("마케팅/홍보")]
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo01",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo01" }
                      },
                      [_vm._v("[필수] 전자상거래에 관한 이용약관")]
                    ),
                    _vm._v(" "),
                    _vm._m(1)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo02",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo02" }
                      },
                      [_vm._v("[필수] Member 계약 동의서")]
                    ),
                    _vm._v(" "),
                    _vm._m(2)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo03",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo03" }
                      },
                      [_vm._v("[필수] Member 유의사항")]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _vm._m(4)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo04",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo04" }
                      },
                      [_vm._v("[필수] 개인정보 수집/이용 동의서")]
                    ),
                    _vm._v(" "),
                    _vm._m(5),
                    _vm._v(" "),
                    _vm._m(6),
                    _vm._v(" "),
                    _vm._m(7)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo06",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo06" }
                      },
                      [_vm._v("[선택] 개인정보 제 3자 제공에 대한 동의")]
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "LOS 관리, 우편물 발송, 유선상담 등 사업적으로 활용할 수 있도록 동의한 경우에 한하여, 상위 혹은 하위 ABO에게 개인정보를 제공하고 있습니다. 동의하지\n                않은 경우 정보 제공이 제한되며, 동의한 경우에도 언제든지 그 동의를 철회할 수 있습니다."
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(8),
                    _vm._v(" "),
                    _vm._m(9)
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c(
                      "strong",
                      {
                        ref: "titNo07",
                        staticClass: "titH1 txt-titH1",
                        attrs: { id: "titNo07" }
                      },
                      [
                        _vm._v(
                          "[선택] 마케팅/홍보 목적의 개인정보 수집 및 이용동의"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "mgtS" }, [
                      _vm._v(
                        "마케팅/홍보를 위하여 귀하의 개인정보를 이용하는데 동의 하십니까? 동의 거부 시 제품 소개, 프로모션, 이벤트 안내 등의 마케팅/홍보\n                정보 제공이 제한됩니다."
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(10),
                    _vm._v(" "),
                    _vm._m(11)
                  ])
                ])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade" } }, [
          _c(
            "div",
            { staticClass: "scrollTopWrapper", attrs: { id: "ScrollTopArea" } },
            [
              _c(
                "button",
                {
                  staticClass: "toTop",
                  attrs: { type: "button" },
                  on: { click: _vm.scrollToTop }
                },
                [_vm._v("TOP(위로이동)")]
              )
            ]
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", {
      staticStyle: { display: "none" },
      attrs: { id: "uiLayerMask" }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "skipToContent" } }, [
      _c("a", { attrs: { href: "#contents" } }, [_vm._v("콘텐츠 바로가기 ")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "box_customer-terms" }, [
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제1조(목적)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext pdbNone" }, [
            _vm._v(
              "이 약관은 한국암웨이 주식회사 (전자거래 사업자)가 운영하는 한국암웨이 사이버몰 (이하\n                      “몰”이라 한다.) 에서 제공하는 인터넷 관련 서비스(이하 “서비스”라 한다)를 이용함에 있어 사이버몰과 이용자의 권리와 의무 및\n                      책임사항을 규정함을 목적으로 합니다."
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "listWarning" }, [
            _vm._v(
              "「PC통신, 무선 등을 이용하는 전자거래에 대해서도 그 성질에 반하지 않는 한 이 약관을 준용합니다.」\n                    "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제2조(정의)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰” 이란 한국암웨이 주식회사가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신 설비를 이용하여 재화 또는\n                        용역을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 사이버 몰을 운영하는 사업자의 의미로도 사용합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “이용자”란 “몰”에 접속하여 이 약관에 따라 “몰”이 제공하는 서비스를 받는 회원 및 비회원을 말합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ ‘회원’이라 함은 “몰”에 개인정보를 제공하여 회원등록을 한 자로서, “몰”의 정보를 지속적으로 제공 받으며, “몰”이\n                        제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ ‘비회원’이라 함은 회원에 가입하지 않고 “몰”이 제공하는 서비스를 이용하는 자를 말합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제3조(약관 등의 명시와 설명 및 개정)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소(소비자의 불만을 처리할 수 있는 곳의 주소를 포함),\n                        전화번호·모사전송번호·전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보 보호책임자 등을 이용자가 쉽게 알 수 있도록\n                        사이버몰의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.\n                      "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자가 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회·배송책임·환불조건 등과 같은 중요한 내용을\n                        이용자가 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 이용자의 확인을 구하여야 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「전자문서 및 전자거래기본법」,\n                        「전자금융거래법」, 「전자서명법」, 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「방문판매 등에 관한 법률」,\n                        「소비자기본법」, 「개인정보 보호법」 등 관련 법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 몰의 초기화면에 그 적용일자 7일 이전부터\n                        적용일자 전일까지 공지합니다. 다만, 이용자에게 불리하게 약관내용을 변경하는 경우에는 최소한 30일 이상의 사전 유예기간을 두고\n                        공지합니다. 이 경우 “몰”은 개정 전 내용과 개정 후 내용을 명확하게 비교하여 이용자가 알기 쉽도록 표시합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑤ “몰”이 약관을 개정할 경우에는 그 개정약관은 그 적용일자 이후에 체결되는 계약에만 적용되고 그 이전에 이미 체결된 계약에\n                        대해서는 개정 전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 이용자가 개정약관 조항의 적용을 받기를 원하는 뜻을\n                        제3항에 의한 개정약관의 공지기간 내에 “몰”에 송신하여 “몰”의 동의를 받은 경우에는 개정약관 조항이 적용됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑥ 이 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제 등에\n                        관한 법률, 공정거래위원회가 정하는 「전자상거래 등에서의 소비자 보호지침」 및 관계법령 또는 상관례에 따릅니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제4조(서비스의 제공 및 변경)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 다음과 같은 업무를 수행합니다.\n                        "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "1. 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("2. 구매계약이 체결된 재화 또는 용역의 배송")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("3. 기타 “몰”이 정하는 업무")])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 재화 또는 용역의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화 또는 용역의\n                        내용을 변경할 수 있습니다. 이 경우에는 변경된 재화 또는 용역의 내용 및 제공일자를 명시하여 현재의 재화 또는 용역의 내용을\n                        게시한 곳에 즉시 공지합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”이 제공하기로 이용자와 계약을 체결한 서비스의 내용을 재화 등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할\n                        경우에는 그 사유를 이용자에게 통지 가능한 주소로 즉시 통지합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 전항의 경우 “몰”은 이로 인하여 이용자가 입은 손해를 배상합니다. 다만, “몰”이 고의 또는 과실이 없음을 입증하는 경우에는\n                        그러하지 아니합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제5조(서비스의 중단)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 컴퓨터 등 정보통신설비의 보수점검·교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로\n                        중단할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다.\n                        단, “몰”이 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 사업종목의 전환, 사업의 포기, 업체 간의 통합 등의 이유로 서비스를 제공할 수 없게 되는 경우에는 “몰”은 제8조에 정한\n                        방법으로 이용자에게 통지하고 당초 “몰”에서 제시한 조건에 따라 소비자에게 보상합니다. 다만, “몰”이 보상기준 등을 고지하지\n                        아니한 경우에는 이용자들의 마일리지 또는 적립금 등을 “몰”에서 통용되는 통화가치에 상응하는 현물 또는 현금으로 이용자에게\n                        지급합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제6조(회원가입)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 이용자는 “몰”이 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다.\n                      "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각 호에 해당하지 않는 한 회원으로 등록합니다.\n                        "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "1. 가입신청자가 이 약관 제7조 제3항에 의하여 이전에 회원자격을 상실한 적이 있는 경우, 다만 제7조 제3항에\n                            의한 회원자격 상실 후 3년이 경과한 자로서 “몰”의 회원재가입 승낙을 얻은 경우에는 예외로 합니다."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("2. 등록 내용에 허위, 기재누락, 오기가 있는 경우")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 기타 회원으로 등록하는 것이 “몰”의 기술상 현저히 지장이 있다고 판단되는 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 회원가입계약의 성립시기는 “몰”의 승낙이 회원에게 도달한 시점으로 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 회원은 제15조 제1항에 의한 등록사항에 변경이 있는 경우, 즉시 전자우편 기타 방법으로 “몰”에 대하여 그 변경사항을 알려야\n                        합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑤ 회원탈퇴 후 재가입시 이전에 ABO였던 회원은 6개월이 경과하여야 ABO로 재가입을 할 수 있습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제7조(회원 탈퇴 및 자격 상실 등)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 회원은 “몰”에 언제든지 탈퇴를 요청할 수 있으며 “몰”은 즉시 회원탈퇴를 처리합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 회원이 다음 각호의 사유에 해당하는 경우, “몰”은 회원자격을 제한 및 정지시킬 수 있습니다.\n                        "
              ),
              _c("ol", [
                _c("li", [_vm._v("1. 가입 신청시에 허위 내용을 등록한 경우")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. “몰”을 이용하여 구입한 재화나 용역 등의 대금, 기타 “몰”이용에 관련하여 회원이 부담하는 채무를 기일에\n                            지급하지 않는 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 다른 사람의 “몰” 이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4. “몰”을 이용하여 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”이 회원 자격을 제한 또는 정지 시킨 후, 동일한 행위가 2회이상 반복되거나 30일이내에 그 사유가 시정되지 아니하는\n                        경우 “몰”은 회원자격을 상실시킬 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소전에\n                        일정기간(30일)을 정하여 소명할 기회를 부여합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제8조(회원에 대한 통지)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”이 회원에 대한 통지를 하는 경우, 회원이 “몰”에 제출한 전자우편 주소로 할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 불특정다수 회원에 대한 통지의 경우 1주일이상 “몰” 게시판에 게시함으로서 개별 통지에 갈음할 수 있습니다. 다만,\n                        회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 개별통지를 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제9조(구매신청)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”이용자는 “몰”상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, “몰”은 이용자가 구매신청을 함에 있어서\n                        다음의 각 내용을 알기 쉽게 제공하여야 합니다.\n                        "
              ),
              _c("ol", [
                _c("li", [_vm._v("1. 재화 등의 검색 및 선택")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. 받는 사람의 성명, 주소, 전화번호, 전자우편주소(또는 이동전화번호) 등의 입력"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 약관내용, 청약철회권이 제한되는 서비스, 배송료, 설치비 등의 비용부담과 관련한 내용에 대한 확인"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    " 4. 이 약관에 동의하고 위 3.호의 사항을 확인하거나 거부하는 표시(예, 마우스 클릭)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5. 재화 등의 구매신청 및 이에 관한 확인 또는 “몰”의 확인에 대한 동의"
                  )
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("6. 결제방법의 선택")])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”이 제3자에게 구매자 개인정보를 제공·위탁할 필요가 있는 경우 실제 구매신청 시 구매자의 동의를 받아야 하며, 회원가입\n                        시 미리 포괄적으로 동의를 받지 않습니다. 이 때 “몰”은 제공되는 개인정보 항목, 제공받는 자, 제공받는 자의 개인정보 이용\n                        목적 및 보유·이용 기간 등을 구매자에게 명시하여야 합니다. 다만 「개인정보 보호법」 제26조에 의한 개인정보 취급위탁의 경우 등\n                        관련 법령에 달리 정함이 있는 경우에는 그에 따릅니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제10조(계약의 성립)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                " ① “몰”은 제9조와 같은 구매신청에 대하여 다음 각 호에 해당하면 승낙하지 않을 수 있습니다. 또한 “몰”은 미성년자의 가입이\n                        불가하므로, 미성년자가 가입시 회원자격이 상실되며, 계약은 취소될 수 있습니다.\n                        "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v("1. 신청 내용에 허위, 기재누락, 오기가 있는 경우")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. 기타 구매신청에 승낙하는 것이 “몰” 기술상 현저히 지장이 있다고 판단하는 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”의 승낙이 제12조 제1항의 수신확인통지형태로 이용자에게 도달한 시점에 계약이 성립한 것으로 봅니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”의 승낙의 의사표시에는 이용자의 구매 신청에 대한 확인 및 판매가능 여부, 구매신청의 정정 취소 등에 관한 정보 등을\n                        포함하여야 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제11조(지급방법)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext" }, [
            _vm._v(
              "“몰”에서 구매한 재화 또는 용역에 대한 대금지급방법은 다음 각 호의 방법 중 가용한 방법으로 할 수\n                      있습니다. 단, “몰”은 이용자의 지급방법에 대하여 재화 등의 대금에 어떠한 명목의 수수료도 추가하여 징수할 수 없습니다."
            )
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v("1. 폰뱅킹, 인터넷뱅킹, 메일뱅킹 등의 각종 계좌이체")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("2. 선불카드, 직불카드, 신용카드 등의 각종 카드 결제")
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("3. 온라인무통장입금")]),
            _vm._v(" "),
            _c("li", [_vm._v("4. 전자화폐에 의한 결제")]),
            _vm._v(" "),
            _c("li", [_vm._v("5. 수령 시 대금지급")]),
            _vm._v(" "),
            _c("li", [
              _vm._v("6. 마일리지 등 “몰”이 지급한 포인트에 의한 결제")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "7. “몰”과 계약을 맺었거나 “몰”이 인정한 상품권에 의한 결제"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("8. 기타 전자적 지급 방법에 의한 대금 지급 등")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제12조(수신확인통지, 구매신청 변경 및 취소)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자의 구매신청이 있는 경우 이용자에게 수신확인통지를 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 수신확인통지를 받은 이용자는 의사표시의 불일치 등이 있는 경우에는 수신확인통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할\n                        수 있고 “몰”은 배송 전에 이용자의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만 이미 대금을 지불한\n                        경우에는 제15조의 청약철회 등에 관한 규정에 따릅니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제13조(재화 등의 공급)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자와 재화 등의 공급시기에 관하여 별도의 약정이 없는 이상, 이용자가 청약을 한 날부터 7일 이내에 재화 등을\n                        배송할 수 있도록 주문제작, 포장 등 기타의 필요한 조치를 취합니다. 다만, “몰”이 이미 재화 등의 대금의 전부 또는 일부를\n                        받은 경우에는 대금의 전부 또는 일부를 받은 날부터 3영업일 이내에 조치를 취합니다. 이때 “몰”은 이용자가 재화 등의 공급 절차\n                        및 진행 사항을 확인할 수 있도록 적절한 조치를 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자가 구매한 재화에 대해 배송수단, 수단별 배송비용 부담자, 수단별 배송기간 등을 명시합니다. 만약 “몰”이 약정\n                        배송기간을 초과한 경우에는 그로 인한 이용자의 손해를 배상하여야 합니다. 다만 “몰”이 고의·과실이 없음을 입증한 경우에는\n                        그러하지 아니합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제14조(환급)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext pdbNone" }, [
            _vm._v(
              "“몰”은 이용자가 구매신청한 재화 등이 품절 등의 사유로 인도 또는 제공을 할 수 없을 때에는\n                      지체 없이 그 사유를 이용자에게 통지하고 사전에 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 3영업일 이내에 환급하거나 환급에\n                      필요한 조치를 취합니다."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제15조(청약철회 등)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”과 재화 등의 구매에 관한 계약을 체결한 이용자는 「방문판매 등에 관한 법률」 및 「전자상거래 등에서의 소비자보호에 관한\n                        법률」에 따라 청약철회를 할 수 있습니다. 해당 법률에 따르면, 계약내용에 관한 서면을 받은 날(그 서면을 받은 때보다 재화 등의\n                        공급이 늦게 이루어진 경우에는 재화 등을 공급받거나 재화 등의 공급이 시작된 날을 말합니다)부터 ABO는 3개월, 소비자는 20일\n                        이내에는 청약의 철회를 할 수 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 이용자는 재화 등을 배송 받은 경우 다음 각 호의 1에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.\n                        "
              ),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "1. 이용자에게 책임 있는 사유로 재화 등이 멸실 또는 훼손된 경우(다만, 재화 등의 내용을 확인하기 위하여 포장\n                            등을 훼손한 경우에는 청약철회를 할 수 있습니다.)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "2. 이용자의 사용 또는 일부 소비에 의하여 재화 등의 가치가 현저히 감소한 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "3. 시간의 경과에 의하여 재판매가 곤란할 정도로 재화 등의 가치가 현저히 감소한 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "4. 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "5. ABO의 경우, 재고 보유에 관하여 다단계판매업자에게 거짓으로 보고하는 등의 방법으로 과다하게 재화 등의\n                            재고를 보유한 경우"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 제2항 제2호 내지 제4호의 경우에 “몰”이 사전에 청약철회 등이 제한되는 사실을 소비자가 쉽게 알 수 있는 곳에 명기하거나\n                        시용상품을 제공하는 등의 조치를 하지 않았다면 이용자의 청약철회 등이 제한되지 않습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 이용자는 제1항 및 제2항의 규정에 불구하고 재화 등의 내용이 표시·광고 내용과 다르거나 계약내용과 다르게 이행된 때에는 당해\n                        재화 등을 공급받은 날부터 3월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에 청약철회 등을 할 수 있습니다.\n                      "
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제16조(청약철회 등의 효과)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자로부터 재화 등을 반환받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다. 이 경우 “몰”이\n                        이용자에게 재화 등의 환급을 지연한 때에는 그 지연기간에 대하여 「방문판매 등에 관한 법률」 및 「전자상거래 등에서의 소비자보호에\n                        관한 법률 시행령」에서 정하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 위 대금을 환급함에 있어서 이용자가 신용카드 또는 전자화폐 등의 결제수단으로 재화 등의 대금을 지급한 때에는 지체\n                        없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 이용자에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다. 다만 재화 등의 내용이 표시·광고 내용과\n                        다르거나 계약내용과 다르게 이행되어 청약철회 등을 하는 경우 재화 등의 반환에 필요한 비용은 “몰”이 부담합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ 이용자가 재화 등을 제공받을 때 발송비를 부담한 경우에 “몰”은 청약철회 시 그 비용을 누가 부담하는지를 이용자가 알기 쉽도록\n                        명확하게 표시합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제17조(개인정보보호)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자의 개인정보 수집시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 회원가입시 구매계약이행에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령상 의무이행을 위하여 구매계약 이전에\n                        본인확인이 필요한 경우로서 최소한의 특정 개인정보를 수집하는 경우에는 그러하지 아니합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 이용자의 개인정보를 수집·이용하는 때에는 당해 이용자에게 그 목적을 고지하고 동의를 받습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”은 수집된 개인정보를 목적외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는\n                        이용·제공단계에서 당해 이용자에게 그 목적을 고지하고 동의를 받습니다. 다만, 관련 법령에 달리 정함이 있는 경우에는 예외로\n                        합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑤ “몰”이 제3항과 제4항에 의해 이용자의 동의를 받아야 하는 경우에는 개인정보관리 책임자의 신원(소속, 성명 및 전화번호,\n                        기타 연락처), 정보의 수집목적 및 이용목적, 제3자에 대한 정보제공 관련사항(제공받은자, 제공목적 및 제공할 정보의 내용) 등\n                        「개인정보 보호법」 제39조가 규정한 사항을 미리 명시하거나 고지해야 하며 이용자는 언제든지 이 동의를 철회할 수 있습니다.\n                      "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑥ 이용자는 언제든지 “몰”이 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 “몰”은 이에 대해 지체\n                        없이 필요한 조치를 취할 의무를 집니다. 이용자가 오류의 정정을 요구한 경우에는 “몰”은 그 오류를 정정할 때까지 당해 개인정보를\n                        이용하지 않습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑦ “몰”은 개인정보 보호를 위하여 이용자의 개인정보를 취급하는 자를 최소한으로 제한하여야 하며 신용카드, 은행계좌 등을 포함한\n                        이용자의 개인정보의 분실, 도난, 유출, 동의 없는 제3자 제공, 변조 등으로 인한 이용자의 손해에 대하여 모든 책임을 집니다.\n                      "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑧ “몰” 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체\n                        없이 파기합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "⑨ “몰”은 개인정보의 수집·이용·제공에 관한 동의란을 미리 선택한 것으로 설정해두지 않습니다. 또한 개인정보의 수집·이용·제공에\n                        관한 이용자의 동의거절시 제한되는 서비스를 구체적으로 명시하고, 필수수집항목이 아닌 개인정보의 수집·이용·제공에 관한 이용자의\n                        동의 거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제18조(“몰”의 의무)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 법령과 이 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며 이 약관이 정하는 바에 따라 지속적이고, 안정적으로\n                        재화·용역을 제공하는데 최선을 다하여야 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자가 안전하게 인터넷 서비스를 이용할 수 있도록 이용자의 개인정보(신용정보 포함)보호를 위한 보안 시스템을\n                        갖추어야 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”이 상품이나 용역에 대하여 「표시·광고의 공정화에 관한 법률」 제3조 소정의 부당한 표시·광고행위를 함으로써 이용자가\n                        손해를 입은 때에는 이를 배상할 책임을 집니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "④ “몰”은 이용자가 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제19조(회원의 ID 및 비밀번호에 대한 의무)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 제17조의 경우를 제외한 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ 회원이 자신의 ID 및 비밀번호를 도난 당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 “몰”에 통보하고 “몰”의\n                        안내가 있는 경우에는 그에 따라야 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제20조(이용자의 의무)")]),
          _vm._v(" "),
          _c("p", { staticClass: "titHtext" }, [
            _vm._v("이용자는 다음 행위를 하여서는 안 됩니다.")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [_vm._v("1. 신청 또는 변경시 허위 내용의 등록")]),
            _vm._v(" "),
            _c("li", [_vm._v("2. 타인의 정보 도용")]),
            _vm._v(" "),
            _c("li", [_vm._v("3. “몰”에 게시된 정보의 변경")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "4. “몰”이 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("5. “몰” 기타 제3자의 저작권 등 지적재산권에 대한 침해")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "6. “몰” 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "7. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 몰에 공개 또는 게시하는 행위"
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제21조(연결“몰”과 피연결“몰” 간의 관계)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① 상위 “몰”과 하위 “몰”이 하이퍼 링크(예: 하이퍼 링크의 대상에는 문자, 그림 및 동화상 등이 포함됨)방식 등으로 연결된\n                        경우, 전자를 연결 “몰”(웹 사이트)이라고 하고 후자를 피연결 “몰”(웹사이트)이라고 합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 연결 “몰”은 피연결 “몰”이 독자적으로 제공하는 재화 및 용역에 의하여 이용자와 행하는 거래에 대해서 보증책임을지지 않는다는\n                        뜻을 연결 “몰”의 사이트에서 명시한 경우에는 그 거래에 대한 보증책임을 지지 않습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제22조(저작권의 귀속 및 이용제한)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”이 작성한 저작물에 대한 저작권 기타 지적 재산권은 “몰” 귀속합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② 이용자는 “몰”을 이용함으로써 얻은 정보 중 “몰”에게 지적재산권이 귀속된 정보를 “몰”의 사전 승낙 없이 복제, 송신,\n                        출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”은 약정에 따라 이용자에게 귀속된 저작권을 사용하는 경우 당해 이용자에게 통보하여야 합니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [_vm._v("제23조(분쟁해결)")]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”은 이용자가 제기하는 정당한 의견이나 불만을 반영하고 그 피해를 보상처리하기 위하여 피해보상처리기구를 설치, 운영합니다.\n                      "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”은 이용자로부터 제출되는 불만사항 및 의견은 우선적으로 그 사항을 처리합니다. 다만, 신속한 처리가 곤란한 경우에는\n                        이용자에게 그 사유와 처리일정을 즉시 통보해 드립니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "③ “몰”과 이용자 간에 발생한 전자상거래 분쟁과 관련하여 이용자의 피해구제신청이 있는 경우에는 공정거래위원회 또는 시·도지사가\n                        의뢰하는 분쟁조정기관의 조정에 따를 수 있습니다."
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("div", { staticClass: "pdBox" }, [
          _c("p", { staticClass: "titH2" }, [
            _vm._v("제24조(재판권 및 준거법)")
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "① “몰”과 이용자 간에 발생한 전자상거래 분쟁에 관한 소송은 제소 당시의 이용자의 주소에 의하고, 주소가 없는 경우에는 거소를\n                        관할하는 지방법원의 전속관할로 합니다. 다만, 제소 당시 이용자의 주소 또는 거소가 분명하지 않거나 외국 거주자의 경우에는\n                        민사소송법상의 관할법원에 제기합니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "② “몰”과 이용자 간에 제기된 전자상거래 소송에는 한국법을 적용합니다."
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "본 계약은 한국암웨이(주)와 신청인 간의 Member등록에 관한 계약입니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member는 한국암웨이(주)의 회원고객이며 단순히 자가소비용으로 제품을 구매하시고자 하는 분이어야 하며 후원활동 및 구입한 제품에 대한 재판매 활동을\n                  하실 수 없습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member는 한국암웨이(주)가 ABO (독립자영사업가)에게 판매하는 제품가격과 동일한 가격으로 제품을 구매하실 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member 신청인은 Member의 제반규정 및 금지조항 등을 충분히 이해하고 숙지할 것과 아울러,\n                  이러한 제반규정 및 금지조항은 Amway 사이트(www.amway.co.kr)에 게재하거나 본인에게 이메일을 통해 개별통지 함으로써 수시로 변경될 수\n                  있으며\n                  그러한 변경은 Amway 사이트(www.amway.co.kr)에 게재된 날로부터 즉시, 개별통지의 경우 회사가 이를 발송한 날로부터 7일이 경과한\n                  날로부터 효력을 발생함에 동의합니다.\n                  만약 신청인이 Member의 제반규정이나 금지사항을 위반할 시 한국암웨이의 재량으로 본인의 Member 자격을 해지할 수 있습니다.\n                "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          'Member는 Amway 사이트(www.amway.co.kr)를 통해서 제품 구매가 가능하며, 구매한 제품에 의해 발생하는 포인트는 "포인트 계산과\n                  사용에 관한규정"에 따라 사용할 것에 동의 합니다.'
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member 신청인은 Member 신청시 기재한 내용을 한국암웨이(주)가 보관하고 전송하는 것을 허용하며 Member 신청시 기재된 내용에 한치의\n                  오차도 없음을 증명합니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "한국암웨이(주)는 필요에 따라 Member 관련 규정을 수정할 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "가입시 반드시 E-Mail이 있어야 하며, 이를 통해 각종 제품 및 사업 정보를 받습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [
        _vm._v(
          "한국암웨이(주)의 Member는 만 19세 이상의 성인만 신청할 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "법적 부부인 경우 하나의 Member ID 가 부여되며 기업이나 단체에게는 허용되지 않습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "법적 부부 중 한명이 ABO인 경우 배우자는 Member로 가입이 불가능하며 등록된 ABO (독립자영사업가) 탈퇴 후 동일한 상위 후원자 아래에서\n                  Member로의 가입은 가능합니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member는 제품 판매활동 및 후원활동을 할 수 없습니다. 만일 이를 위반할시에는 Member 자격해지 등을 포함한 조치를 받을 수 있습니다.\n                "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("Member의 월간 최대 구매PV는 2,399,999 PV 로 제한되어 있습니다.")
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member로 등록하기 위해서는 상위 후원자 ABO가 있어야 합니다. 단, 처음으로 Member로 등록하시는 분 중 상위 후원자가 없을 경우 한국암웨이\n                  고객지원센터 <1588 - 0080> 으로 문의하시면 자세히 안내해드립니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member 의 가입은Amway 사이트(www.amway.co.kr) 에서 가능하며 반드시 본인의 법정 생년월일 및 휴대폰번호를 통한 인증 확인을 거친\n                  후 가입이 가능합니다. 전화 및 서류 등록 접수는 받지 않습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "Member 신청인의 기재사항이 불명확하거나 하자가 있는 경우 신청등록이 지연되거나 처리되지 않을 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("li", [_vm._v("외국인은 등록이 불가능합니다.")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pdBox mgtL" }, [
      _c("p", { staticClass: "titH2" }, [
        _vm._v("포인트 계산과 사용에 관한 규정")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "titHtext" }, [
        _vm._v(
          "Member가 구매한 모든 제품에는 PV (판매점수치) / 또는 BV (판매가격치)가 있으며 이를 통해 Member의\n                  포인트가 계산됩니다. 포인트는 Member의 월간 총 구매PV의 합계에 의해 결정되며 현금으로 지급되는 것이 아니라 Amway\n                  사이트(www.amway.co.kr) 에서 제품을 구매할 시에 현금처럼 사용할 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v("가. 포인트 계산 방법\n                    "),
          _c("ul", { staticClass: "mglM" }, [
            _c("li", [
              _c("strong", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v("월간 총 구매 PV가 0 ~ 199,999 PV :")
              ]),
              _vm._v("\n                        해당사항 없음")
            ]),
            _vm._v(" "),
            _c("li", [
              _c("strong", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(
                  "월간 총 구매 PV가 200,000 PV ~ 599,999 PV 인\n                        경우 :"
                )
              ]),
              _vm._v(" 월간 BV 총합계의 3%를 포인트로 적립")
            ]),
            _vm._v(" "),
            _c("li", [
              _c("strong", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(
                  "월간 총 구매 PV가 600,000 PV ~ 1,199,999 PV\n                        :"
                )
              ]),
              _vm._v(" 월간 BV 총합계의 6%를 포인트로 적립")
            ]),
            _vm._v(" "),
            _c("li", [
              _c("strong", { staticStyle: { "font-weight": "bold" } }, [
                _vm._v(
                  "월간 총 구매 PV가 1,200,000 PV ~ 2,399,999\n                        PV :"
                )
              ]),
              _vm._v(" 월간 BV 총합계의 9%를 포인트로 적립")
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "예를들어, Member의 A의 월간 총 구매금액이 50만원이고 해당하는 구매 PV 및 BV를 모두 더한 결과 각각 409,090\n                        PV / 490,000 BV이었다면 위의 누적 포인트는 아래와 같이 계산됩니다."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Member A의 구매 PV가 200,000 PV ~ 599,999 PV 사이에 있으므로 월간 BV 총합계인 490,000 BV의\n                        3%가 포인트로 적립되므로 490,000 BV의 3% 인 14,700 포인트가 적립됩니다."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v("\n                    나. 포인트 적립\n                    "),
          _c("p", { staticClass: "mglS" }, [
            _vm._v(
              "위와 같이 계산된 포인트는 구매 익월 15일 이후에 적립이 되며 적립된 포인트는 바로 사용 가능합니다.(1\n                      point = 1 원) 예를 들어, 5월 한달동안 구입하신 제품에 대한 포인트는 6월 15일 이후에 적립되며 바로 현금과 동일하게\n                      Amway 사이트(www.amway.co.kr)에서 제품 구매시에만 사용 가능합니다. 단, Member 에서 ABO 로 전환시 미\n                      사용하신 포인트는 모두 소멸됨을 반드시 숙지하시기 바랍니다."
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v(" 다. 포인트 사용\n                    "),
          _c("p", { staticClass: "mglM" }, [
            _vm._v(
              "적립된 포인트로 한국암웨이(주)가 제공하는 제품을 구입할 시에는 신용카드 및 현금과 혼용해서 사용할 수 없으며\n                      포인트로 구입한 제품에 대한 환불은 포인트로 재 적립해 드립니다."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titH2 mgtL" }, [
        _vm._v("Member 의 탈퇴 및 후원자 변경에 관한 규정")
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(" 가. Member 탈퇴"),
          _c("p", [
            _vm._v(
              "한국 암웨이 Member에서 탈퇴하고자 하는 경우 Amway 사이트(www.amway.co.kr)에서 탈퇴신청을\n                    하시면 됩니다. Member 탈퇴시 기존에 적립된 포인트는 모두 소멸되며 이후에 재 가입시에 사용하실 수 없습니다."
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(" 나. Member의 후원자 변경"),
          _c("p", [
            _vm._v(
              "한국암웨이 Member가 후원자 변경을 할 시에는 아래와 같은 제한 사항이 있으며 후원자 변경요청은 월\n                    1회에 한하며 후원자 변경이 유효한 시점은 변경요청한 익월 1일부터 입니다."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titH2 mgtL" }, [
        _vm._v("Member와 ABO간의 자격전환 및 후원자 변경")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext mgbS" }, [
        _vm._v(
          "한국암웨이 Member가 후원자 변경을 할 시에는 아래와 같은 제한 사항이 있으며 후원자 변경요청은 월 1회에\n                  한하며 변경 요청 시 즉시 반영 합니다."
        ),
        _c("br"),
        _vm._v("(단, 당월 실적이 있는 경우 변경 불가합니다.)")
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("p", { staticClass: "listWarning" }, [
            _vm._v(
              "ABO에서 Member로 전환 또는 ABO 탈퇴 후 동일 후원자 내에서의 전환 시 익일에 Member로\n                      가입 가능합니다."
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("p", { staticClass: "listWarning" }, [
            _vm._v(
              "단, 직전에 ABO였던 Member가 상위 후원자를 변경 할 시에 ABO 탈퇴 후 6개월 비활동 규정을\n                      적용 합니다."
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("p", { staticClass: "listWarning" }, [
            _vm._v(
              "Member에서 ABO로 전환 시 미 사용한 포인트는 ABO 전환과 동시에 소멸됩니다."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titH2 mgtL" }, [
        _vm._v("상품대금 또는 용역대가의 지급시기 및 방법")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          "한국암웨이 제품을 구입하고자 하는 Member는 원포원 제품과 일부 제품의 (www.amway.co.kr) 에서 제품대금을\n                  카드 혹은 온라인 입금을 통해서 결제하실 수 있습니다. 입금이 확인이 된후 주문시 요청된 주소지까지 배달됩니다. 배달 수수료 및 기타 자세한 제품 주문\n                  방법은 Amway 사이트(www.amway.co.kr)상에 공지된 내용을 참조하십시오."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titH2 mgtM" }, [
        _vm._v("상품의 인도시기 또는 용역의 제공시기")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          "제품 주문 대금의 지불 확인 후 주문을 확정하는 시점부터 통상 1일부터 5일 사이에 주문시 신청된 주소지로 배달되며,\n                  6만원이상 물품구매 시 배송료는 무료이나 6만원 미만인 경우 지역에 관계없이 3,300원의 배달수수료가 부과됩니다. 참고로 배달 소요일자 계산에서\n                  일요일과 공휴일은 제외됩니다. 주문제품의 인도에 관한 기타 상세한 정보는 Amway 사이트(www.amway.co.kr)상에 공지된 내용을 참조\n                  하십시오."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titH2 mgtM" }, [
        _vm._v("상품 또는 용역의 반환에 관한 규정")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          "한국암웨이로부터 구입한 상품과 용역을 반환 하고자 하면 반환할 제품과 동제품의 구매사실을 입증하는 영수증을 첨부하여\n                  한국암웨이(주)에 제출하면 됩니다. Member 의 반품은 소비자 반품으로서 제품을 수령한 날로부터 20일 이내에만 허용되며 별도의 반품수수료는 공제\n                  되지 않습니다. 반품신청은 상위 후원자 ABO 또는 각 지역 Amway Business Center 에서 하실 수 있습니다. Amway Business\n                  Center 연락처등은 Amway 사이트(www.amway.co.kr)상에 공지된 내용을 참조 하시기 바랍니다."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titH2 mgtM" }, [
        _vm._v("상품의 품질보증 및 사후관리에 관한 사항")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          '암웨이 "소비자 만족 보증제도"와 기타 "품질 보증서"에 따라 암웨이 제품을 구입한 소비자의 보호와 품질보증에 만전을\n                  기하고 있습니다. 암웨이 "소비자 만족 보증제도는 암웨이 제품을 사용한 소비자가 제품의 품질에 만족하지 못해 반환한 경우 제품대금의 환불이나 다른\n                  제품으로 교환해주는 소비자 보호제도입니다. 그러나 고의나 자신의 부주의로 손상된 제품에 대해서는 본 제도가 적용되지 않습니다. 이와 함께 일부 제품에는\n                  "소비자기본법"에 의거 품질 표시에 관한 내용과 품질 보증조건 및 부품보유기간을 표시한 품질 보증서를 첨부하여 동 제품 사용으로 인한 소비자 피해를\n                  보상하고 있습니다. 아울러, 품질보증서가 없을 경우 공정거래위원회 고시 "소비자분쟁해결기준"에 의거, 관련 유사제품의 보상기준에 준해 보상해 드립니다.\n                '
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "listWarning" }, [
        _vm._v(
          "원포원 제품과 일부 제품의 경우 일반 반품규정이 상이하오니, 제품 카탈로그를 참조하십시오."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-table" }, [
      _c("table", { staticClass: "tbl-type1 line-st" }, [
        _c("caption", [
          _vm._v("개인정보 수집/이용 동의서 현황을 보여주는 표 : 목적, 항목")
        ]),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("구분")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("목적")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("항목")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("th", { attrs: { scope: "row" } }, [_vm._v("필수정보")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "\n                      서비스 이용에 따른 본인 식별, 각종 서비스 관련 고지사항 전달"
              ),
              _c("br"),
              _vm._v(
                "\n                      고객 상담 (제품 A/S 접수 및 처리포함), 불만 및 민원처리"
              ),
              _c("br"),
              _vm._v(
                "\n                      청구서 등 각종 관련 서류 및 주문 물품 배송"
              ),
              _c("br"),
              _vm._v(
                "\n                      물품구입에 따른 요금결제, 반품/환불, 세금 신고"
              ),
              _c("br"),
              _vm._v(
                "\n                      서비스 및 제품 품질 향상을 위한 활용"
              ),
              _c("br"),
              _vm._v(
                "\n                      Customer의 경우 추가적으로 기 ABO 가입 및 중복가입 방지\n                    "
              )
            ]),
            _vm._v(" "),
            _c("td", [
              _c("ul", [
                _c("li", [
                  _vm._v("- "),
                  _c("b", [_vm._v("회원가입 시:")]),
                  _c("br"),
                  _vm._v(
                    " Member: 성명, 회원ID, 비밀번호, 생년월일, 성별, 이메일,\n                          휴대폰번호\n                          "
                  ),
                  _c("br"),
                  _vm._v(
                    " Customer: 성명, 회원ID, 생년월일, 성별, 이메일, 휴대폰번호, 카카오 고유식별정보\n                        "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("- "),
                  _c("b", [_vm._v("주문/거래 시:")]),
                  _vm._v(
                    " 신용카드정보(카드 주문 시), 은행계좌정보 (무통장 입금 시), 주문/거래 기록\n                        "
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("- "),
                  _c("b", [_vm._v("서비스 이용 시:")]),
                  _vm._v(
                    " 서비스 이용기록, 이용정지 기록, 이용해지 기록, 접속로그, 쿠키(Cookie),\n                          접속 IP, 국가"
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("th", { attrs: { scope: "row", rowspan: "2" } }, [
              _vm._v("선택정보")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v("\n                      고객 상담 및 응대"),
              _c("br"),
              _vm._v("\n                      고객 불만 접수 및 민원처리"),
              _c("br"),
              _vm._v("\n                      고지사항 전달"),
              _c("br"),
              _vm._v("\n                      물품 배송\n                    ")
            ]),
            _vm._v(" "),
            _c("td", [
              _c("ul", [
                _c("li", [_vm._v("- Member: 집 전화번호")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "- 받는 분 성명, 받는 분 주소, 집 전화번호 또는 휴대폰 (배송지 관리 메뉴 이용 시)"
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "- Amway Wallet, 현대카드 발급 시: CI(외부연계 식별정보), DI (중복가입 확인정보)"
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_vm._v("제품소개, 프로모션, 이벤트 안내")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "카카오프로필 (닉네임/프로필 사진), 전화번호, 이메일, 생년월일, 성별"
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v(
          "마케팅 홍보 목적으로 선택적 수신동의에 따라 이메일/SMS/알림톡으로 서비스를 제공합니다."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v(
          "위 정보는 가입 당시 정보뿐만 아니라 정보 수정으로 변경된 정보를 포함합니다."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v(
          "필수항목은 회원 가입을 위해서 필요한 최소한 개인정보이므로 동의를 해주셔야 서비스를 이용하실 수 있습니다."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v("선택항목은 입력하지 않으셔도 서비스 이용에 제한이 없습니다.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mgtS" }, [
      _c("p", { staticClass: "titHtext" }, [
        _vm._v("(공통) 개인정보 이용 보유기간")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v("회원탈퇴 시까지 보관"),
        _c("br"),
        _vm._v(
          "\n                  단, 회사 내부 방침 및 관련 법령에 의해 보관하여야 할 경우, 아래와 같이 이용 및 보유함."
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "box_list-indent" }, [
        _c("li", { staticClass: "mgtS" }, [
          _vm._v("1. 소비자 기본법\n                    "),
          _c("p", [
            _vm._v(
              "- 사후관리(A/S, 부품교체 및 정보 제공 등)의 목적으로 개인정보, 구매정보, 정수기 및 공기청정기 부품교체 정보에 관한 기록:\n                      "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("7년")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v(
            "2. 전자상거래 등에서의 소비자 보호에 관한 법률\n                    "
          ),
          _c("p", [
            _vm._v("- 표시, 광고에 관한 기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("6개월")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 계약 또는 청약철회 등의 대금결제 및 재화 등의 공급에 관한 기록: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("5년")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("- 소비자의 불만 또는 분쟁처리에 관한 기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("3년")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v("3. 통신비밀보호법\n                    "),
          _c("p", [
            _vm._v("- 이용자의 인터넷 등 로그기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("3개월")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("- 이용자의 접속지 추적자료 그 외의 통신사실 확인 자료: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("1년")]
            )
          ])
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "mgtS" }, [
          _vm._v(
            "4. 회사 내부 방침에 의한 정보보유 사유\n                    "
          ),
          _c("p", [
            _vm._v("- 부정이용기록: "),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("사업 종료\n                      시까지")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 콜센터 및 홈페이지, 챗봇 채팅 서비스를 통한 A/S 접수/상담 시 수집된 개인정보: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("7년")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 제품 A/S, 교환, 환불, 홈페이지 상 소모품 구매 시 수집된 개인정보: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("7년")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "- 홈페이지 이메일 문의, 고객의 소리 이용 시 수집된 개인정보: "
            ),
            _c(
              "strong",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [_vm._v("3년")]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "mgtS",
        staticStyle: {
          "border-top": "1px solid rgb(218, 218, 218)",
          "padding-top": "10px"
        }
      },
      [
        _c("p", [
          _vm._v("더 자세한 내용에 대해서는 한국암웨이 주식회사 "),
          _c(
            "a",
            {
              staticStyle: { color: "blue", "text-decoration": "underline" },
              attrs: { href: "https://www.amway.co.kr/compliance/info-policy" }
            },
            [_vm._v("개인정보처리방침")]
          ),
          _vm._v("을 참고하시기 바랍니다.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-table mgtS" }, [
      _c("table", { staticClass: "tbl-type1 line-st" }, [
        _c("caption", [
          _vm._v(
            "개인정보 제 3자 제공에 대한 동의 현황을 보여주는 표 : 제공받는 자, 이용목적, 제공항목, 보유기간"
          )
        ]),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("제공받는 자")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("이용목적")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("제공항목")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("보유 및 이용기간")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c(
              "td",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [
                _vm._v(
                  "본인이 속한 ABO 그룹 스폰서 및 LOS상의 동 그룹\n                      내 상의 ABO"
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [
                _vm._v(
                  "ABO 조직관리, 제품정보 등의 DM 발송, 교육,\n                      유선 상담, 체험프로그램 제공"
                )
              ]
            ),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "회원번호, 이름, 전화번호, 실적, 주문 및 반품 내역 (제품명, 결제방법, 거래명세 확인, 배송지 확인, 주문 처리 및\n                      취소여부, 환불 여부), 미수금 여부"
              )
            ]),
            _vm._v(" "),
            _c(
              "td",
              { staticStyle: { color: "#002f5f", "font-weight": "600" } },
              [
                _vm._v(
                  "서비스 제공 종료 시까지 또는 동의 철회 시까지\n                    "
                )
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mgtS" }, [
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          "* 본인이 속한 ABO 그룹 스폰서 및 LOS상의 동 그룹 내 상위 ABO (제공받는 자)는 가입완료 후 마이페이지에서\n                  확인할 수 있습니다. "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "titHtext" }, [
        _vm._v(
          "* 본 제3자 정보제공동의를 거부할 수 있습니다. 만일, 거부하더라도, 일체의 불이익은 없습니다."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scroll-table mgtS" }, [
      _c("table", { staticClass: "tbl-type1 line-st" }, [
        _c("caption", [
          _vm._v(
            "마케팅/홍보 목적의 개인정보 수집 및 이용동의 현황을 보여주는 표 : 구분, 목적, 항목, 이용보유기간"
          )
        ]),
        _vm._v(" "),
        _c("thead", [
          _c("tr", [
            _c("th", { attrs: { scope: "col" } }, [_vm._v("구분")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("목적")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("항목")]),
            _vm._v(" "),
            _c("th", { attrs: { scope: "col" } }, [_vm._v("보유 및 이용기간")])
          ])
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_vm._v("광고성 정보 수신")]),
            _vm._v(" "),
            _c("td", [_vm._v("제품소개, 프로모션, 이벤트 안내")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "카카오 프로필 (닉네임/프로필사진), 전화번호, 이메일, 생년월일, 성별"
              )
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("동의철회시 / 회원탈퇴시")])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box_compliance-agree" }, [
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v("[선택] 마케팅 홍보 목적의 이메일 수신동의")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "txt-italic" }, [
        _vm._v("[선택] 마케팅 홍보 목적의 SMS 수신동의")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mgtS" }, [
        _vm._v("* [선택] 항목은 동의하지 않더라도 가입이 가능합니다.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mgtS" }, [
        _vm._v(
          "* '마케팅/혜택 정보 수신' 동의를 철회하시면 본 목적으로서의 개인 정보 처리는 중지됩니다."
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ac4da0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ac4da0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/amwayterms/termsMember.vue
// module id = null
// module chunks = 